export default __webpack_public_path__ + "static/media/chevron-down.9eaa1a62.svg";